module.exports = __webpack_public_path__ + "img/20190624161703419.5087e44b.png";